import React from "react"
import styled, { css } from 'styled-components'
import { Title, Item } from '../../../shared/Section'
import { AccordionBox, AccordionInner } from './AccordionBox'
import LinkButton from '../../../shared/Buttons/LinkButton'

import * as notes from '../../../../images/Attention/note'
import * as measures from '../../../../images/Attention/measure'

const NumHead = styled.div`
  ${({ theme: { font, breakpoints }}) => css`
    display: flex;
    flex-direction: row;
    p {
      font-family: ${font.en};
      font-size: 3.2rem;
      line-height: 3.2rem;
      font-weight: 500;
    }
    span {
      padding-left: 1.2rem;
      font-size: 1.8rem;
      line-height: 3.2rem;
    }
    @media (min-width: ${breakpoints.md}px) {
      flex-direction: column;
      text-align: center;
      span {
        padding-left: 0;
        font-size: 1.4rem;
        line-height: 5.6rem;
      }
    }
  `}
`

const NoteList = styled.ol`
`

const NoteListItem = styled.li`
  ${({ theme: { breakpoints }}) => css`
    & + & {
      margin-top: 6.4rem;
    }
    @media (min-width: ${breakpoints.md}px) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
    }
  `}
`

const NoteHeader = styled.h4`
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      flex: 1 0;
    }
  `}
`

const NoteContent = styled.div`
  padding-top: 2.4rem;
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      flex: 4 0;
    }
  `}
`

const List = styled.ul`
  // margin: 12px 0;
  padding-left: 20px;
`

const ListItem = styled.li`
  display: block;
  position: relative;
  line-height: 2.0;
  &:before {
    content: '・ ';
    position: absolute;
    // top: -2px;
    left: -20px;
  }
  span {
    display: inline-block;
  }
`

const CheckList = styled.ul`
  margin: 12px 0;
  padding-left: 20px;
`

const CheckListItem = styled.li`
  display: block;
  position: relative;
  line-height: 2.0;
  &:before {
    content: "□ ";
    position: absolute;
    top: -2px;
    left: -20px;
  }
`

const ImageList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      justify-content: left;
    }
  `}
`

const ImageListItem = styled.li`
  min-width: 15.0rem;
`

const NoteImageList = styled(ImageList)`

`

const MeasureImageList = styled(ImageList)`
  padding-top: 4.0rem;
  margin: 0 auto;
  max-width: 600px;
`

const Attention = () => {
  
  return (
    <>
      {/* <Content title={"Attention"}> */}
      <Title>Attention</Title>
      <Item>
        <ul>
          <AccordionBox title={'来場者の皆様へのお願い'}>
            <AccordionInner>
              <NoteList>
                <NoteListItem>
                  <NoteHeader><NumHead><p>1</p><span>来場方法</span></NumHead></NoteHeader>
                  <NoteContent>
                    <List>
                      <ListItem>
                        <p>会場内の過密を防ぐため、入場制限を実施します。</p>
                        <div style={{ padding: '2.0rem 0' }}>
                          <p><strong>事前予約:</strong> なるべく事前予約の上、ご来場ください。<LinkButton href="https://reserva.be/sotuten2021">予約サイトはこちら</LinkButton></p>
                          <p><strong>当日入場:</strong> 予約優先のため、当日の混雑状況によってはお待ちいただく場合があります。</p>
                        </div>
                      </ListItem>
                      <ListItem>
                        <p>入場前に、LINEコロナお知らせシステム「神奈川県LINE公式アカウント」の友達登録をお願いします。</p>
                      </ListItem>
                      <ListItem>
                        <p>スマートフォンをお持ちでない方は、入場記録のための署名を控えさせていただきます。</p>
                      </ListItem>
                    </List>
                  </NoteContent>
                </NoteListItem>
                <NoteListItem>
                  <NoteHeader><NumHead><p>2</p><span>誓約事項</span></NumHead></NoteHeader>
                  <NoteContent>
                    <p>1つでも当てはまる方は来場できません。</p>
                    <CheckList>
                      <CheckListItem><p>37.5 度以上の発熱がある。</p></CheckListItem>
                      <CheckListItem><p>頭痛・強いだるさや息苦しさがある。</p></CheckListItem>
                      <CheckListItem><p>風邪のような症状がある(喉の痛み、咳)。</p></CheckListItem>
                      <CheckListItem><p>味覚・臭覚に異常を感じる。</p></CheckListItem>
                      <CheckListItem><p>家族等の同居人が新型コロナウイルスに罹患した、またはその疑いで自宅待機となっている。</p></CheckListItem>
                      <CheckListItem><p>新型コロナウイルスに罹患した疑いのある者との濃厚接触がある。</p></CheckListItem>
                      <CheckListItem><p>上記7項目の症状・事象が過去 14 日以内にある。</p></CheckListItem>
                      <CheckListItem><p>過去 14 日以内に渡航歴(流行地域)がある。</p></CheckListItem>
                    </CheckList>
                  </NoteContent>
                </NoteListItem>
                <NoteListItem>
                  <NoteHeader><NumHead><p>3</p><span>お願い</span></NumHead></NoteHeader>
                  <NoteContent>
                    <NoteImageList>
                      <ImageListItem><img src={notes.icon1} alt="来場者へのお願い" /></ImageListItem>
                      <ImageListItem><img src={notes.icon2} alt="来場者へのお願い" /></ImageListItem>
                      <ImageListItem><img src={notes.icon3} alt="来場者へのお願い" /></ImageListItem>
                      <ImageListItem><img src={notes.icon4} alt="来場者へのお願い" /></ImageListItem>
                      <ImageListItem><img src={notes.icon5} alt="来場者へのお願い" /></ImageListItem>
                      <ImageListItem><img src={notes.icon6} alt="来場者へのお願い" /></ImageListItem>
                    </NoteImageList>
                  </NoteContent>
                </NoteListItem>
              </NoteList>
            </AccordionInner>
          </AccordionBox>
          <AccordionBox title={'会場・スタッフの感染対策'}>
            <AccordionInner>
              <p>当展示は、多摩美術大学・赤レンガ倉庫のガイドラインに則り、以下の感染対策を実施しております。</p>
              <List>
                <ListItem>会場内に手指消毒液を設置します。</ListItem>
                <ListItem>スタッフは在廊時に検温を行い、手洗いうがい、手指消毒などの自己管理を徹底します。</ListItem>
                <ListItem>来場者及びスタッフの感染が確認された際は、保健所と適切に連携して対応するとともに、 必要に応じウェブサイト等でお知らせします。<span>（念のため、来館された日時をご自身で記録しておくことをお勧めします。）</span></ListItem>
              </List>
              <MeasureImageList>
                <ImageListItem><img src={measures.icon1} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon7} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon8} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon9} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon10} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon11} alt="来場者へのお願い" /></ImageListItem>
                <ImageListItem><img src={measures.icon12} alt="来場者へのお願い" /></ImageListItem>
              </MeasureImageList>
            </AccordionInner>
          </AccordionBox>
        </ul>
      </Item>
      {/* </Content> */}
    </>
  )
}

export default Attention
